import globalFooter from '../../re_footer';
import { compoundUrl } from '@ui/packages/pcv2/assets/utils/util';
export default {
  name: 'refooter',
  components: {
    globalFooter: globalFooter
  },
  data: function data() {
    return {
      brand: 'LiveMe+'
    };
  },
  computed: {
    crtime: function crtime() {
      return new Date().getFullYear();
    }
  },
  methods: {
    getHeaderLink: function getHeaderLink(pathname) {
      return compoundUrl(pathname, true);
    }
  }
};